module.exports = "/assets/data/868696acb398d4da220c1e340f49f180-HA6.data.json";